import { createApiCall } from 'lib/base';

const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';

const createSubscriptionApi = createApiCall<{ payload: any }>(
  CREATE_SUBSCRIPTION,
  ({ payload }) => ({
    endpoint: `api/admin/subscriptions`,
    method: 'POST',
    body: payload,
  })
);

export default createSubscriptionApi;
